<template>
    <v-fab-transition>
        <v-btn
            fab
            small
            dark
            fixed
            bottom
            right
            color="rgba(45, 147, 55, 0.7)"
            class="fab-icon"
            v-show="fab"
            v-scroll="onScroll"
            @click="toTop"
        >
            <v-icon medium>keyboard_arrow_up</v-icon>
        </v-btn>
    </v-fab-transition>
</template>

<script>
export default {
    name: "AppFab",

    data: () => ({
        fab: false
    }),

    methods: {
        toTop() {
            this.$vuetify.goTo(0, { duration: 1000, easing: "easeOutCubic" })
        },

        onScroll() {
            if (typeof window === "undefined") return

            const top = window.pageYOffset || document.documentElement.offsetTop || 0
            this.fab = top > 300
        }
    }
}
</script>

<style>
.fab-icon:hover {
    width: 50px;
    height: 50px;
}
</style>
